import React from 'react';
import {connect} from 'react-redux';

import {isVP} from '../../../utils/auth';
import {roleName} from '../../../utils/formatting';

import {UserModalContainer} from './UserModal';

import RhinoModal from '../../common/modal/RhinoModal';
import RhinoLoading from '../common/RhinoLoading';

import * as storesActionCreators from '../../../actions/stores';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, storesActionCreators, usersActionCreators);


class UserDetail extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      userSearchInput: '',
    };
  }

  // getEmployeeList() {
  //   return this.props.stores.selectedLocation ? this.props.stores.selectedLocation.employees : this.props.business.business.employees;
  // }

  selectLoction(evt) {
    let locationId = evt.target.value;
    if(locationId === '') {
      this.props.storesSetSelectedLocation(null);
    }
    for(let i = 0; i < this.props.stores.locations.length; i++) {
      if(this.props.stores.locations[i].id == locationId) {
        this.props.storesSetSelectedLocation(this.props.stores.locations[i]);
      }
    }
  }

  cloneArray(source) {
    let result = [];
    for(let n = 0; n < source.length; n++) {
      result[n] = source[n];
    }
    return result;
  }

  getFilteredResult() {

    let clone = this.cloneArray(this.props.users.users);
    let filteredResults = [];

    for(let i = 0; i < clone.length; i++) {

      let inputLower = this.state.userSearchInput.toLowerCase();

      let firstLower = clone[i].first_name.toLowerCase();
      let lastLower = clone[i].last_name.toLowerCase();
      let nameLower = firstLower + ' ' + lastLower;
      let emailLower = clone[i].email.toLowerCase();
      // let phoneLower = clone[i].phone.toString().toLowerCase();

      if(inputLower === '' || firstLower.includes(inputLower) || lastLower.includes(inputLower) || nameLower.includes(inputLower) || emailLower.includes(inputLower)) {
        filteredResults.push(clone[i]);
      }
    }
    return filteredResults;
  }

  changeSearchInput(evt) {
    this.setState({ userSearchInput: evt.target.value });
  }

  getLocationNameList(locations, role) {

    if(role !== 'VP') {
      return locations[0].name;
    }

    let nameList = [];
    for(const loc of locations) {
      nameList.push(loc.name);
    }
    return nameList.join(', ');
  }

  render() {

    let entryCount = 0;

    return <div className='UserDetail'>
      <div className='detailHeader'>
        <div className='detailTitle'>
          {this.props.stores.selectedLocation ? this.props.stores.selectedLocation.name + ' Users' : 'All Users'}
        </div>
        <div className='detailLocations'>
          <select onChange={this.selectLoction.bind(this)}>
            <option value=''>Select location</option>
            <option value=''>All locations</option>
            {this.props.stores.locations.map((location, i) => {
              return <option value={location.id} key={i}>{location.name}</option>
            })}
          </select>
        </div>
        <div className='detailAddWrapper'>
          <div className={'detailAdd actionButton'} onClick={() => {this.props.usersModalOpen(null)}}>Add User</div>
        </div>
        <div className='detailSearch'>
          <div className='searchLabel'>Search Users</div>
          <div className='inputWrapper'>
            <input type='text' placeholder='Search by name and/or email' value={this.state.userSearchInput} onChange={this.changeSearchInput.bind(this)} />
          </div>
        </div>
      </div>
      <div className='detailBody'>
        {this.props.users.users === null ?
          <div className='loadingEmployees'>
            <RhinoLoading message='Loading users' />
          </div> :
          <div className='usersWrapper'>
            {this.getFilteredResult().map((user, i) => {

              if(this.props.stores.selectedLocation !== null && ((user.locations.length > 0 && user.locations[0].id !== this.props.stores.selectedLocation.id) || user.locations.length === 0)) {
                return null;
              }

              entryCount++;
              return <div className={'userEntry'} key={i}>
                <div className='nameWrapper'>{user.first_name + ' ' + user.last_name}</div>
                <div className='emailWrapper'>{user.email}</div>
                <div className='roleWrapper'>{roleName(user.role)}</div>
                <div className='locationWrapper'>
                  {user.locations.length > 0 ?
                    <span>{this.getLocationNameList(user.locations, user.role)}</span> :
                    null
                  }
                </div>
                <div className='editLink' onClick={() => {this.props.usersModalOpen(user)}}>Edit</div>
              </div>;
            })}
            {entryCount === 0 ?
              <div className='nullUsers'>
                No users found for the current filters
              </div> :
              null
            }
          </div>
        }        
      </div>
      <RhinoModal
        open={this.props.users.modalOpen}
        resize={this.props.common.modalResize}>
        <UserModalContainer />
      </RhinoModal>
    </div>;
  }
}
export default UserDetail;

function mapStateToProps(state) {
  return {
    common: state.common,
    stores: state.stores,
    users: state.users,
  };
}

export const UserDetailContainer = connect(
  mapStateToProps,
  allActionCreators
)(UserDetail);